import { motion } from "framer-motion";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { scrollToSection } from "@/App";

const fadeUp = (delay) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { delay, duration: 0.7, ease: "easeOut" },
});

export const Hero = () => {
  return (
    <section data-testid="hero-section" className="relative bg-ink overflow-hidden">
      <img
        src="https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxzdGVlbCUyMGZhY3RvcnklMjBpbnRlcmlvciUyMGRhcmt8ZW58MHx8fHwxNzg1NTIxNDc5fDA&ixlib=rb-4.1.0&q=85"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover opacity-25"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-royal/70 via-ink/80 to-ink pointer-events-none" />
      <div className="absolute inset-0 texture-perf opacity-40 pointer-events-none" />

      <div className="relative max-w-[1440px] mx-auto px-5 md:px-10 pt-32 md:pt-44 pb-16 md:pb-24 text-center">
        <motion.p
          data-testid="hero-eyebrow"
          {...fadeUp(0.1)}
          className="font-mono text-[10px] md:text-xs tracking-[0.35em] uppercase text-smoke"
        >
          Welcome to D V Steels — Cable Tray Manufacturing Unit
        </motion.p>

        <motion.h1
          {...fadeUp(0.25)}
          className="mt-6 font-heading font-semibold uppercase text-4xl md:text-6xl lg:text-7xl leading-[1.05] tracking-wide text-white max-w-4xl mx-auto"
        >
          Perforated Cable Trays, <span className="text-[#7FB3E8]">Built to Last.</span>
        </motion.h1>

        <motion.p
          {...fadeUp(0.4)}
          className="mt-6 max-w-2xl mx-auto font-body text-sm md:text-base text-smoke leading-relaxed"
        >
          We manufacture perforated cable trays, ladder trays and accessories — punched,
          formed and finished in-house at our Ranipur, Pathankot unit. Standard sizes
          ready for dispatch; custom fabrication to your drawings.
        </motion.p>

        <motion.div {...fadeUp(0.55)} className="mt-9 flex flex-wrap items-center justify-center gap-4">
          <button
            data-testid="hero-explore-button"
            onClick={() => scrollToSection("#products")}
            className="btn-sweep btn-solid font-heading font-semibold uppercase tracking-wider text-lg px-8 py-3 flex items-center gap-2"
          >
            Explore Products <ArrowRight size={18} />
          </button>
          <button
            data-testid="hero-quote-button"
            onClick={() => scrollToSection("#contact")}
            className="btn-sweep btn-ghost font-heading font-semibold uppercase tracking-wider text-lg px-8 py-3 flex items-center gap-2"
          >
            Request Quote <ArrowUpRight size={18} />
          </button>
        </motion.div>

        <motion.div {...fadeUp(0.7)} className="mt-14 md:mt-20 mx-auto max-w-2xl">
          <div className="clip-br bg-white p-4 md:p-8 shadow-[0_30px_60px_rgba(0,0,0,0.45)]">
            <img
              src="/assets/trays-frame.png"
              alt="Cable trays manufactured by D V Steels"
              className="w-full h-auto object-contain"
            />
          </div>
          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-8 gap-y-2 font-mono text-[10px] md:text-xs tracking-[0.25em] uppercase text-smoke">
            <span data-testid="hero-spec-1">Perforated / Ladder / Accessories</span>
            <span data-testid="hero-spec-2">PG • HDG • Powder Coated</span>
            <span data-testid="hero-spec-3">Ranipur, Pathankot — Punjab</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
